import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const asset = (u) => (!u ? "" : u.startsWith("http") ? u : `${BACKEND_URL}${u}`);

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const CATEGORIES = [
  { value: "micro-flip", label: "Micro-Flips", hint: "Under $1,000 quick flips" },
  { value: "inventory", label: "Inventory & Commission", hint: "Help sell stock for a cut" },
  { value: "growth-capital", label: "Growth Capital", hint: "Larger raises to scale" },
  { value: "equipment", label: "Equipment Arbitrage", hint: "Buy low, resell higher" },
  { value: "liquidation", label: "Liquidation", hint: "Bulk stock for resellers" },
  { value: "pallet-split", label: "Pallet Split", hint: "Co-fund a lot, split it" },
];

export const AUCTION_CATEGORIES = [
  { value: "estate-lot", label: "Estate & Collection Lots" },
  { value: "collectibles", label: "Collectibles" },
  { value: "antiques", label: "Antiques" },
  { value: "art", label: "Art" },
  { value: "jewelry-watches", label: "Jewelry & Watches" },
  { value: "coins-currency", label: "Coins & Currency" },
  { value: "electronics", label: "Electronics" },
  { value: "furniture", label: "Furniture" },
  { value: "vehicles", label: "Vehicles" },
  { value: "fashion", label: "Fashion" },
  { value: "other", label: "Other" },
];

export const DEAL_TYPES = [
  { value: "investment", label: "Investment (profit share)" },
  { value: "commission", label: "Commission (help sell)" },
  { value: "liquidation", label: "Liquidation (bulk sale to resellers)" },
  { value: "pool", label: "Pallet Split (group co-funding)" },
];

export const catLabel = (v) =>
  AUCTION_CATEGORIES.find((c) => c.value === v)?.label ||
  CATEGORIES.find((c) => c.value === v)?.label ||
  v;

export const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(n || 0));

export const timeLeft = (endsIso) => {
  const ms = new Date(endsIso).getTime() - Date.now();
  if (ms <= 0) return { ended: true, label: "Ended", urgent: true };
  const d = Math.floor(ms / 86400000);
  const h = Math.floor((ms % 86400000) / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  const s = Math.floor((ms % 60000) / 1000);
  const label = d > 0 ? `${d}d ${h}h` : h > 0 ? `${h}h ${m}m` : m > 0 ? `${m}m ${s}s` : `${s}s`;
  return { ended: false, label, urgent: ms < 3600000 };
};
